import React from 'react';
import { Button } from '../../../../shared/components/ui/Button';

interface LoginButtonProps {
  loading: boolean;
  text?: string; 
}

export const LoginButton: React.FC<LoginButtonProps> = ({ loading, text }) => {
  return (
    <Button
      type="submit"
      variant="contained"
      fullWidth
      disabled={loading}
      sx={{
        background: '#2D4BFF',
        color: '#fff',
        fontWeight: 600,
        fontSize: 18,
        borderRadius: 8,
        padding: '12px 0',
        boxShadow: '0 2px 8px 0 rgba(45, 75, 255, 0.10)',
        marginBottom: 1,
        '&:disabled': {
          opacity: 0.7,
        },
      }}
    >
      <svg width="20" height="20" fill="none" stroke="#fff" strokeWidth="2" viewBox="0 0 24 24" style={{ marginRight: 8 }}>
        <path d="M5 12h14M12 5l7 7-7 7"/>
      </svg>
      {loading ? (text === 'Criar' ? 'Criando...' : 'Entrando...') : (text || 'Entrar')}
    </Button>
  );
};